import { render } from "./EquipeAlcadaDespesasModal.vue?vue&type=template&id=40fd03fe&ts=true"
import script from "./EquipeAlcadaDespesasModal.vue?vue&type=script&lang=ts"
export * from "./EquipeAlcadaDespesasModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__